module.exports = __webpack_public_path__ + "img/3d-avatar.50ddfe9c.png";